import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { Layout } from 'components';
import { AuthGuard } from 'pages';
import { useInactivityHandler } from 'hooks';
import { routes } from './config';

const AppRouter = () => {
  useInactivityHandler();
  return (
    <BrowserRouter basename={process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}>
      <ScrollToTop />
      <Routes>
        {/* A route with the Layout component */}
        {/* In the layout component we do all the calls to the backend */}
        <Route element={<Layout />}>
          {/* Mapping over the routes defined in the config file to create a Route for each one */}
          {routes.map(
            (
              {
                path,
                requireAuth,
                requirePasswordChange,
                requiredGroups,
                requiredPrivileges,
                requireConfirmRegistration,
                Element,
              },
              index
            ) => (
              <Route
                key={index}
                path={path}
                element={
                  <AuthGuard
                    requireAuth={requireAuth}
                    requirePasswordChange={requirePasswordChange}
                    requiredGroups={requiredGroups}
                    requiredPrivileges={requiredPrivileges}
                    requireConfirmRegistration={requireConfirmRegistration}
                  >
                    <Element />
                  </AuthGuard>
                }
              />
            )
          )}
        </Route>
        <Route path="*" element={<Navigate to="/fundingpage" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return null;
}
